import './App.css';
import { useEffect, useState } from "react";
import { getStudents, createStudent, updateStudent, deleteStudent } from "./api";


function App() {
  const [students, setStudents] = useState([]);
  const [name, setName] = useState("");
  const [age, setAge] = useState("");

  useEffect(() => {
    getStudents().then((res) => setStudents(res.data));
  }, []);

  const handleAdd = () => {
    const newStudent = {
      student_id: Math.floor(Math.random() * 10000),
      name,
      age: parseInt(age),
    };
    createStudent(newStudent).then(() =>
      getStudents().then((res) => setStudents(res.data))
    );
    setName("");
    setAge("");
  };

  const handleDelete = (id) => {
    deleteStudent(id).then(() =>
      getStudents().then((res) => setStudents(res.data))
    );
  };

  const handleUpdate = (id) => {
    const newName = prompt("Enter new name:");
    const newAge = prompt("Enter new age:");
    if (!newName || !newAge) return;

    const updatedStudent = { student_id: id, name: newName, age: parseInt(newAge) };
    updateStudent(id, updatedStudent).then(() =>
      getStudents().then((res) => setStudents(res.data))
    );
  };

  return (
    <div className="app">
      <h1>Student Management</h1>

      <ul>
        {students.map((s) => (
          <li key={s.student_id}>
            <span>{s.name} (Age: {s.age})</span>
            <div>
              <button className="update-btn" onClick={() => handleUpdate(s.student_id)}>Update</button>
              <button className="delete-btn" onClick={() => handleDelete(s.student_id)}>Delete</button>
            </div>
          </li>
        ))}
      </ul>

      <div className="form">
        <input
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          placeholder="Age"
          value={age}
          onChange={(e) => setAge(e.target.value)}
        />
        <button onClick={handleAdd}>Add Student</button>
      </div>
    </div>
  );
}

export default App;
